import HSForm_FormHelpers from "./FormHelpers";
import HSForm_EmailVerification from "./EmailVerification";
import HSForm_PhoneVerification from "./PhoneVerification";
import HSForm_Multistep from "./Multistep";
import HSForm_Events from "./Events";
import HSForm_AddressHelpers from "./AddressHelpers";

var HSForm = new Object();

HSForm.version = "1.0.3";
HSForm.count = 1; // for testing

HSForm.$el = null;

HSForm.formSettings = function ($el) {
  this.$el = $el;
  HSForm.portalId = "23623022";
  HSForm.formId = $el.attr("form-id");
  HSForm.classes = $el.attr("form-class");
  HSForm.customFormReady = $el.attr("form-ready");
  HSForm.customFormSubmitted = $el.attr("form-submitted");
  HSForm.targetId = "#" + $el.find(".form-target").attr("id");
  HSForm.terms = $el.attr("form-terms");
  HSForm.style = $el.attr("form-style");
  HSForm.phoneValidation = $el.attr("form-phone");
  HSForm.response = $el.attr("form-response") ? $el.find(".form-response").html() : false;
  HSForm.submitText = $el.attr("form-submit-text") ?? false;
};

HSForm.ready = function ($el) {
  // console.log('HSForm.ready', this.count++);
  this.$el = $el;

  // console.log('HSForm.init...!', $el);

  this.formSettings($el);

  this.initForm();

  HSForm_Events.listen();
};
HSForm.initForm = function () {
  let submitText = this.submitText ?? "";
  let inlineMessage = this.response ?? "";
  hbspt.forms.create({
    region: "na1",
    portalId: this.portalId,
    formId: this.formId,
    cssClass: this.classes,
    target: this.targetId,
    onFormReady: this.onFormReady,
    onFormSubmitted: this.onFormSubmitted,
    submitButtonClass: "btn btn-orange hspacing1 uppercase semibold",
    inlineMessage,
    submitText,
  });

  // console.log(inlineMessage);

  // console.log(`HS Portal ID: ${this.portalId}`);
  // console.log(`HS Form ID: ${this.formId}`);
};

HSForm.onFormReady = function ($form) {
  var _this = HSForm;

  if (helpers.shouldDebug("hsForm")) {
    console.log("[HSForm] onFormReady", _this.count++);
    console.log("[HSForm] onFormReady", $form);
  }

  HSForm_FormHelpers.field_privacyConsent($form, HSForm.terms);
  HSForm_FormHelpers.field_name($form);
  HSForm_FormHelpers.field_website($form);
  HSForm_FormHelpers.field_industry($form);
  HSForm_FormHelpers.field_adp4($form);
  HSForm_FormHelpers.field_baSFID($form);
  HSForm_FormHelpers.fields_utms($form);
  HSForm_FormHelpers.fields_country($form);
  HSForm_FormHelpers.setFieldLabelVisibilty($form);

  HSForm_EmailVerification.init($form);
  HSForm_PhoneVerification.init($form, HSForm.style, HSForm.phoneValidation);
  HSForm_Multistep.init($form);

  if (typeof google !== "undefined") {
    HSForm_AddressHelpers.init($form);
  }

  let customReadyFn = new Function(HSForm.customFormReady);
  customReadyFn($form);

  HSForm_FormHelpers.field_textarea($form);
};

HSForm.onFormSubmitted = function ($form, data) {
  var _this = HSForm;

  jQuery(".form-instructions").addClass("d-none");

  const currStep = parseInt(_this.$el[0].getAttribute("data-step"));
  const nextStep = currStep + 1;

  _this.$el[0].setAttribute("data-step", nextStep);

  let customSubmittedFn = new Function(HSForm.customFormSubmitted);
  customSubmittedFn($form);

  // console.log('HSForm.onFormSubmitted', _this.count++);
  // console.log('HSForm.onFormSubmitted', $form, data);
};

window.HSForm = HSForm;
